module.exports = __webpack_public_path__ + "static_portal/img/report_short_2.932c52cb.jpg";